import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { PreCartComponent } from './pre-cart.component';
import { UserDetailsResolver } from 'src/app/shared/resolvers/user-details.service';
import { StoreService } from 'src/app/shared/resolvers/store.service';
import { MenuService } from 'src/app/shared/resolvers/menu.service';

export const routes = [
  { path: '', component: PreCartComponent, pathMatch: 'full' , 
    resolve: {userDetails: UserDetailsResolver,store:StoreService}, 
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule
  ],
  declarations: [
    PreCartComponent
  ],
})
export class PreCartModule { }
